// removed by extract-text-webpack-plugin
module.exports = {"task-table":"index__task-table___2ZxBy","task-tr":"index__task-tr___3zzMZ","task-td":"index__task-td___3foVC","task-th":"index__task-th___3lZX2","text-btn":"index__text-btn___K005v"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Dashboard/components/openActivity/index.less
// module id = 1283
// module chunks = 3